import { Component, signal, OnInit, inject, AfterViewInit } from '@angular/core';
import { RouterOutlet, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
// import { Footer } from "./core/footer/footer";
// import { Header } from "./core/header/header";
import { filter, map } from 'rxjs/operators';
import { Renderer2, Inject, DOCUMENT } from '@angular/core';
import { ThemeService } from './core/services/theme.service';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SessionSync } from './modules/student/services/session-sync';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit, AfterViewInit {
  protected readonly title = signal('bellaspeak-web');
  private doc = inject(DOCUMENT);

  private supportedLangs = ['en', 'es', 'fr', 'hi', 'ja', 'ar', 'zh', 'ru', 'pt', 'tr', 'it', 'de'];

  showLayout = false;

  private routerSubscription!: Subscription;

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private themeService: ThemeService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    inject(SessionSync).init();
  }

  ngOnInit(): void {
    // Single NavigationEnd subscription handles both showLayout and lang.
    // Fires AFTER router fully resolves all routes including lazy modules.
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      const showLayout = route.snapshot.data['showLayout'];
      this.showLayout = showLayout !== false;

      const lang = this.activatedRoute.firstChild?.snapshot.params['lang'] || 'en';
      this.setLangFromUrl(lang);
    });

    // ✅ REMOVED: checkInitialRoute() — was firing synchronously before
    // lazy modules resolved, causing timing conflicts.
    // ✅ REMOVED: console.log(this.showLayout) — was the line 62 "true" print.

    const setDir = (lang: string) => {
      const dir = lang === 'ar' ? 'rtl' : 'ltr';
      this.doc.documentElement.setAttribute('dir', dir);
      this.doc.documentElement.setAttribute('lang', lang);
    };

    setDir(this.translate.currentLang || this.translate.defaultLang || 'en');
    this.translate.onLangChange.subscribe(event => setDir(event.lang));
  }


  // mat-icons-loading issue fixed : start 
  ngAfterViewInit(): void {
    document.fonts
      .load('24px "Material Symbols Outlined"')
      .then(() => {
        document.body.classList.add('app-ready');
      });
  }
  // mat-icons-loading issue fixed : end 

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  private handleRTL(language: string): void {
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    this.renderer.setAttribute(this.document.documentElement, 'dir', direction);
    this.renderer.setAttribute(this.document.body, 'dir', direction);
  }

  private setLangFromUrl(lang: string): void {
    const languageToUse = this.supportedLangs.includes(lang) ? lang : 'en';
    // ✅ FIX: Use absolute path starting with /bs/ to avoid relative path
    // resolution issues. When on /bs/en/student/dashboard, a relative path
    // like ./static/i18n/en.json resolves to /bs/en/student/static/i18n/en.json
    // which is a 404. The absolute path always resolves correctly.
    this.http.get(`/bs/static/i18n/${languageToUse}.json`).subscribe({
      next: (translations: any) => {
        this.translate.setTranslation(languageToUse, translations);
        this.translate.setDefaultLang(languageToUse);
        this.translate.use(languageToUse);
        this.handleRTL(languageToUse);
      },
      error: (error) => {
        console.error('Error loading translations:', error);
      }
    });
  }
}